import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, createBlock as _createBlock, withDirectives as _withDirectives, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "d-flex flex-wrap flex-stack gap-3 mb-6" }
const _hoisted_2 = { class: "d-flex flex-wrap gap-3 w-100 w-md-auto w-lg-auto" }
const _hoisted_3 = { class: "svg-icon svg-icon-3" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-arrow-repeat fs-1 text-gray-800 d-none d-md-block" }, null, -1)
const _hoisted_5 = { class: "d-block d-md-none" }
const _hoisted_6 = { class: "d-flex w-100 w-md-auto w-lg-auto" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { key: 0 }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-three-dots-vertical fs-2 text-hover-primary me-4 cursor-pointer" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_empty = _resolveComponent("el-empty")!
  const _component_DialogUser = _resolveComponent("DialogUser")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_el_input, {
          modelValue: _ctx.search,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.search) = $event)),
          type: "text",
          class: "w-100 w-md-auto w-lg-300px",
          placeholder: _ctx.t('search')
        }, {
          prefix: _withCtx(() => [
            _createElementVNode("span", _hoisted_3, [
              _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen021.svg" })
            ])
          ]),
          _: 1
        }, 8, ["modelValue", "placeholder"]),
        _createVNode(_component_el_tooltip, {
          effect: "dark",
          content: _ctx.t('update'),
          placement: "top"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_button, {
              plain: "",
              onClick: _ctx.getListUsers,
              class: "w-100 w-md-auto w-lg-auto"
            }, {
              default: _withCtx(() => [
                _hoisted_4,
                _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.t('update')), 1)
              ]),
              _: 1
            }, 8, ["onClick"])
          ]),
          _: 1
        }, 8, ["content"])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.openModal(null))),
          class: "w-100 w-md-auto w-lg-auto"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.t('register')), 1)
          ]),
          _: 1
        })
      ])
    ]),
    (_ctx.listUsers.length > 0)
      ? _withDirectives((_openBlock(), _createBlock(_component_el_table, {
          key: 0,
          data: _ctx.filteredList,
          border: "",
          "table-layout": 'auto'
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, { label: "Nombres y apellidos" }, {
              default: _withCtx(({ row }) => [
                _createElementVNode("span", null, _toDisplayString(row.firstname) + " " + _toDisplayString(row.lastname) + " " + _toDisplayString(row.surname), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              prop: "username",
              label: "Usuario"
            }),
            _createVNode(_component_el_table_column, {
              prop: "avatar",
              label: "Contraseña"
            }, {
              default: _withCtx(({ row }) => [
                _createVNode(_component_el_input, {
                  type: row.showPassword ? 'text' : 'password',
                  modelValue: row.coincidence,
                  "onUpdate:modelValue": ($event: any) => ((row.coincidence) = $event),
                  readonly: ""
                }, {
                  suffix: _withCtx(() => [
                    _createElementVNode("i", {
                      class: _normalizeClass(`fs-2 text-hover-primary cursor-pointer bi bi-eye-${row.showPassword ? 'fill' : 'slash-fill'}`),
                      onClick: ($event: any) => (_ctx.togglePassword(row))
                    }, null, 10, _hoisted_7)
                  ]),
                  _: 2
                }, 1032, ["type", "modelValue", "onUpdate:modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              prop: "perfil_name",
              label: _ctx.t('profile')
            }, null, 8, ["label"]),
            _createVNode(_component_el_table_column, { label: "Fecha de inicio" }, {
              default: _withCtx(({ row }) => [
                _createElementVNode("span", null, _toDisplayString(_ctx.moment(row.date_start).format("DD/MM/YYYY")), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, { label: "Fecha de Termino" }, {
              default: _withCtx(({ row }) => [
                (row.date_end)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_ctx.moment(row.date_end).format("DD/MM/YYYY")), 1))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, { label: "Estado" }, {
              default: _withCtx(({ row }) => [
                _createElementVNode("span", {
                  class: _normalizeClass(`badge badge-${row.status_class}`)
                }, _toDisplayString(row.status_name), 3)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "Opciones",
              width: "120",
              align: "center"
            }, {
              default: _withCtx(({ row }) => [
                _createVNode(_component_el_tooltip, {
                  effect: "dark",
                  content: _ctx.t('delete'),
                  placement: "left"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("i", {
                      class: "bi bi-trash fs-2 text-hover-danger me-4 cursor-pointer",
                      onClick: ($event: any) => (_ctx.onDelete(row))
                    }, null, 8, _hoisted_9)
                  ]),
                  _: 2
                }, 1032, ["content"]),
                _createVNode(_component_el_tooltip, {
                  effect: "dark",
                  content: 'Más opciones',
                  placement: "top"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_dropdown, { trigger: "click" }, {
                      dropdown: _withCtx(() => [
                        _createVNode(_component_el_dropdown_menu, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_dropdown_item, {
                              onClick: ($event: any) => (_ctx.openModal(row))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("Editar cuenta")
                              ]),
                              _: 2
                            }, 1032, ["onClick"]),
                            _createVNode(_component_el_dropdown_item, {
                              onClick: ($event: any) => (_ctx.onDelete(row))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("Eliminar")
                              ]),
                              _: 2
                            }, 1032, ["onClick"])
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      default: _withCtx(() => [
                        _hoisted_10
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["data"])), [
          [_directive_loading, _ctx.loader]
        ])
      : _withDirectives((_openBlock(), _createBlock(_component_el_empty, {
          key: 1,
          description: _ctx.t('empty')
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: _ctx.getListUsers
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.t('tryAgain')), 1)
              ]),
              _: 1
            }, 8, ["onClick"])
          ]),
          _: 1
        }, 8, ["description"])), [
          [_directive_loading, _ctx.loader]
        ]),
    _createVNode(_component_DialogUser, {
      ref: "DialogUserRef",
      idinstitution: _ctx.id,
      "item-user": _ctx.itemUser,
      onOnResponse: _ctx.onResponse,
      "list-status": _ctx.setting.status
    }, null, 8, ["idinstitution", "item-user", "onOnResponse", "list-status"])
  ], 64))
}